<template>
  <div class="wrapper">
    <div class="look-nav" style="justify-content: center">
      <div class="look-nav-center">人员设置</div>
    </div>
    <div class="personnel-content">
      <div class="personnel-box" v-for="(data,index) in permissionsData" :key="index">
        <div class="personnel-title">{{data.title}}</div>
        <div class="personnel-contain">
          <div class="personnel-contain-item" v-for="(item,ind) in data.children" :key="ind">
            {{item.name}}
            <div class="icon-font delete-icon" @click="deleteSingle(item.id)">&#xe6f3;</div>
          </div>
        </div>
        <div class="personnel-operation">
          <div class="personnel-add" @click="showAddModal(index)">
            <div class="icon-font">&#xe640;</div>
            <a>添加</a>
          </div>
          <div class="personnel-clean" @click="showCleanModal(data.children,index)">
            <div class="icon-font">&#xe739;</div>
            <a>清空</a>
          </div>
        </div>
      </div>
      <transition name="fade">
        <div class="alert-box" v-if="showClean">
          <div class="alert-content">
            <div class="alert-content-title">清空提醒</div>
            <div class="alert-content-msg">是否确认清空选中数据?</div>
            <div class="alert-content-btn">
              <div class="btn-cancel button" @click="cancelSingleClean">取消</div>
              <div class="btn-confirm button" @click="confirmSingleClean">确认</div>
            </div>
          </div>
        </div>
      </transition>
      <transition name="fade">
        <div class="alert-box" v-if="showAdd">
          <div class="alert-content" style="width: auto">
            <div class="alert-content-title">选择人员</div>
            <div class="alert-content-msg">
              <el-tree
                :data="treeData"
                show-checkbox
                node-key="id"
                ref="tree"
                highlight-current
                :props="defaultProps">
              </el-tree>
            </div>
            <div class="alert-content-btn">
              <div class="btn-cancel button" @click="cancelAdd">取消</div>
              <div class="btn-confirm button" @click="confirmAdd">确认</div>
            </div>
          </div>
        </div>
      </transition>
    </div>
    <img class="wrapper-icon" src="../../../assets/content-box.png"/>
  </div>
</template>

<script>
export default {
  name: 'Personnel',
  data: function () {
    return {
      type: '',
      value: '',
      showAdd: false,
      showClean: false,
      permissionsData: [
        {
          title: '虫情审核权限：',
          type: '0',
          children: []
        },
        {
          title: '计划单审核权限：',
          type: '1',
          children: []
        },
        {
          title: '月损耗上限权限：',
          type: '2',
          children: []
        },
        {
          title: '任务发布权限：',
          type: '3',
          children: []
        }
      ],
      nameData: [
        {name: '小明', id: 4, department: '质检部'},
        {name: '张三', id: 5, department: '养护部'},
        {name: '李四', id: 6, department: '养护部'},
        {name: '王五', id: 7, department: '养护部'},
        {name: '赵六', id: 8, department: '养护部'}
      ],
      treeData: [
        {
          id: 1,
          label: '质检部',
          children: [{
            id: 4,
            label: '小明',
            title: '质检部'
          }]
        },
        {
          id: 2,
          label: '养护部',
          children: [
            {
              id: 5,
              label: '张三',
              title: '养护部'
            },
            {
              id: 6,
              label: '李四',
              title: '养护部'
            }
          ]
        },
        {
          id: 3,
          label: '养护部',
          children: [
            {
              id: 7,
              label: '王五',
              title: '养护部'
            },
            {
              id: 8,
              label: '赵六',
              title: '养护部'
            }
          ]
        }
      ],
      defaultProps: {
        children: 'children',
        label: 'label'
      }
    }
  },
  methods: {
    backPath: function () {
      this.$router.go(-1)
    },
    deleteSingle: function (id) {
      this.permissionsData.map((data, index) => {
        data.children.map((item, ind) => {
          if (item.id === id) {
            data.children.splice(ind, 1)
            this.$message({
              message: '删除成功！',
              type: 'success',
              center: 'true',
              duration: '1000'
            })
          }
        })
      })
    },
    showCleanModal: function (item, index) {
      console.log(item)
      if (item.length !== 0) {
        this.showClean = true
        this.type = index
      } else {
        this.$message({
          message: '数据已清空',
          type: 'success',
          center: 'true',
          duration: '1000'
        })
      }
    },
    cancelSingleClean: function () {
      this.showClean = false
    },
    confirmSingleClean: function () {
      this.permissionsData[this.type].children = []
      this.showClean = false
      this.$message({
        message: '清空成功！',
        type: 'success',
        center: 'true',
        duration: '1000'
      })
    },
    cancelAdd: function () {
      this.showAdd = false
    },
    showAddModal: function (index) {
      this.showAdd = true
      this.value = index
    },
    confirmAdd: function () {
      this.showAdd = false
      let keys = []
      let selectKeys = this.$refs.tree.getCheckedKeys(true)
      console.log(selectKeys)
      if (selectKeys === []) {
        this.$message({
          message: '请选择添加人员！',
          type: 'warning',
          center: 'true',
          duration: '1000'
        })
      } else {
        selectKeys.map((data) => {
          if (data !== 1 && data !== 2 && data !== 3) {
            keys.push(data)
            this.nameData.map((item, ind) => {
              if (item.id === data) {
                this.permissionsData[this.value].children.push({
                  name: item.name + '(' + item.department + ')',
                  id: item.id
                })
              }
            })
          }
        })
        console.log(keys)
        this.$message({
          message: '添加成功！',
          type: 'success',
          center: 'true',
          duration: '1000'
        })
      }
    }
  }
}
</script>

<style scoped>
@import "./Personnel.css";
</style>



// WEBPACK FOOTER //
// src/page/basic/personnel/Personnel.vue